// extracted by mini-css-extract-plugin
export default {"overlay":"LogoInput_overlay__20D1Z"};